// Maps normalized bookings into AIEmpower payload shape

interface BookingPayload {
  bookingId: string;
  jobId: string;
  resourceId: string;
  title: string;
  category: string | null;
  requiredSkills: string[];
  siteLocation: string | null;
  start: string | null;
  end: string | null;
  durationMinutes: number;
}

export function mapBookings(bookings: BookingPayload[]): { bookings: BookingPayload[] } {
  return { bookings };
}
